import styled from 'styled-components';
import { LinkButton } from '../../../../CommonComponents/Button';

export const ItemTitle = styled.h3`
  font-weight: 700;
  font-size: 14px;
  color: #444;
  margin: 14px 0 6px 0;
`;

export const ItemContent = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #444;
`;

export const StyledLinkButton = styled(LinkButton)`
  font-size: 12px;
  font-weight: 600;
  color: #444;
  margin-top: 24px;

  span {
    color: #0078D4;
  }
`;
